// Category constants for the Budget Planner Pro app

export const INCOME_CATEGORIES = [
  'Employment',
  'Freelance',
  'Investments',
  'Government',
  'Other Income',
];

export const EXPENSE_CATEGORIES = [
  'Housing',
  'Food',
  'Transportation',
  'Utilities',
  'Entertainment',
  'Health',
  'Insurance',
  'Personal',
  'Education',
  'Savings',
  'Debt Payments',
  'Other Expenses',
];

export const ALL_CATEGORIES = [...INCOME_CATEGORIES, ...EXPENSE_CATEGORIES];

// Auto-assign category based on preset item label
export const PRESET_CATEGORY_MAP = {
  // Income presets
  'Salary':         'Employment',
  'Freelance':      'Freelance',
  'Side Hustle':    'Freelance',
  'Part-time Job':  'Employment',
  'Investments':    'Investments',
  'Rental Income':  'Investments',
  // Expense presets
  'Rent / Mortgage': 'Housing',
  'Car Payment':     'Transportation',
  'Car Insurance':   'Insurance',
  'Groceries':       'Food',
  'Coffee':          'Food',
  'Netflix':         'Entertainment',
  'Phone':           'Utilities',
  'Internet':        'Utilities',
  'Utilities':       'Utilities',
  'Gym':             'Health',
};

export const CURRENCY_OPTIONS = [
  { code: 'USD', symbol: '$', label: 'USD — US Dollar' },
  { code: 'CAD', symbol: 'CA$', label: 'CAD — Canadian Dollar' },
  { code: 'EUR', symbol: '€', label: 'EUR — Euro' },
  { code: 'GBP', symbol: '£', label: 'GBP — British Pound' },
  { code: 'AUD', symbol: 'A$', label: 'AUD — Australian Dollar' },
];

export function getCurrencySymbol(code) {
  return CURRENCY_OPTIONS.find(c => c.code === code)?.symbol || '$';
}
